import {createAction, createReducer} from 'redux-act';
import {
    WizardOptionType,
    getOptions,
    getPreviousUpsells,
    getCurrentUpsells,
    getColors,
    getIndependedOptions,
} from '@optimaxdev/wizard-ms';
import {FormattedColorType} from 'features/wizardMs/selectors/upsells/upsells';
import {FULFILLED} from 'redux-promise-middleware';
import {UsageItemType} from 'features/wizardMs/reducers/usages/usages';

import {getWizard} from '../wizardData/wizardData';

export type UpsellsType = {
    previousItems: Array<WizardOptionType>;
    items: Array<WizardOptionType>;
    independedOptions: Array<WizardOptionType>;
    colors: FormattedColorType | {};
    isLensTypeChosen: boolean;
};

export const initialState: UpsellsType = {
    previousItems: [],
    items: [],
    colors: {},
    independedOptions: [],
    isLensTypeChosen: false,
};

/**
 * Get all upsells by selected usage and active package
 */
export const getUpsells = createAction('GET_WIZARD_UPSELLS', (selectedUsage, activePackage) => ({
    selectedUsage,
    activePackage,
}));

/**
 * Set sunglasses colors when usage was changed
 */
export const setColors = createAction<{
    selectedUsage: UsageItemType;
}>('SET_WIZARD_SUNGLASSES_COLORS', ({selectedUsage}) => ({
    selectedUsage,
}));

/**
 * Replace upsell which has depends on option
 */
export const replaceUpsell = createAction('REPLACE_WIZARD_UPSELL', (newItems, isActive) => ({
    newItems,
    isActive,
}));

/**
 * Upsells reducer
 */
export const upsells = createReducer<UpsellsType>(
    /**
     * Subscribe actions
     * https://www.npmjs.com/package/redux-act#typescript
     */
    {
        [`${getWizard}_${FULFILLED}`]: (state, {data: {tree}}) => ({
            ...state,
            independedOptions: getIndependedOptions(tree),
        }),
        [`${setColors}`]: (state: UpsellsType, {selectedUsage}) => ({
            ...state,
            colors: getColors(selectedUsage),
        }),
        [`${getUpsells}`]: (state: UpsellsType, {activePackage, selectedUsage}) => ({
            ...state,
            items: getOptions(selectedUsage, activePackage),
        }),
        [`${replaceUpsell}`]: (state: UpsellsType, {newItems, isActive}) => {
            const items = {
                newItems,
                currentItems: state.items,
                previousItems: state.previousItems,
            };

            return {
                ...state,
                previousItems: getPreviousUpsells(items, isActive),
                items: getCurrentUpsells(items, isActive),
            };
        },
    },
    initialState,
);

/**
 * Setting is lens type chosen. It needs for displaying preselect "Clear" option
 */
export const setIsLensTypeChosen = createAction<boolean>('SET_IS_LENS_TYPE_CHOSEN');
